import { gql } from '@apollo/client';

export const PROPERTY_SAVED = gql`
  subscription propertySaved {
    propertySaved {
      id
      propertyContexts {
        propertyId
        contextId
      }
    }
  }
`;

export const PROPERTY_DETAILS_UPDATED = gql`
  subscription propertyDetailsUpdated {
    propertyDetailsUpdated {
      propertyId
    }
  }
`;

export const PROPERTY_USER_GROUPS_UPDATED = gql`
  subscription propertyUserGroupsUpdated {
    propertyUserGroupsUpdated {
      propertyId
    }
  }
`;
